export enum AlertType {
    info,
    warning,
    error,
}
